import { connect } from 'react-redux';
import { HomePage } from './HomePage';

function mapStateToProps(state) {
  return {
    pages: state.pages,
  };
}

export const HomeContainer = connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./ui/views/home/HomeContainer.js